import MusicPreset from './preset'
import Analyze from './analyze'
import Lyric from './lyric'
import Music from './music'

MusicPreset.Analyze = Analyze
MusicPreset.Lyric = Lyric
MusicPreset.Music = Music

export default MusicPreset